import { useEffect } from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import type { FormApi } from 'final-form';

import { ChatInput } from './chat-input.component';

type ChatFormProps = {
  onSubmit: (values: { question: string }) => void;
  formRef: React.MutableRefObject<FormApi<{ question: string }> | null>;
  isStreaming?: boolean;
  variant?: 'default' | 'large';
};

const FormContent = ({
  handleSubmit,
  form,
  formRef,
  isStreaming,
  variant,
}: {
  handleSubmit: () => void;
  form: FormApi<{ question: string }>;
  formRef: React.MutableRefObject<FormApi<{ question: string }> | null>;
  isStreaming?: boolean;
  variant?: 'default' | 'large';
}) => {
  useEffect(() => {
    formRef.current = form;
  }, [form, formRef]);

  return (
    <form onSubmit={handleSubmit}>
      <ChatInput onSubmit={handleSubmit} isStreaming={isStreaming} variant={variant} />
    </form>
  );
};

export const ChatForm = ({ onSubmit, formRef, isStreaming, variant }: ChatFormProps) => {
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{ question: '' }}
      render={({ handleSubmit, form }: FormRenderProps<{ question: string }>) => (
        <FormContent
          handleSubmit={handleSubmit}
          form={form}
          formRef={formRef}
          isStreaming={isStreaming}
          variant={variant}
        />
      )}
    />
  );
};
